export default {
  metadata: {
    title: 'Contact us to arrange a demo or speak to our sales team. - artificial',
    desc: 'Get in touch to arrange a demo or to speak to our world-class team of insurance experts.',
  },
  ArHeroHeader: {
    title: 'Contact Us',
    description: [
      'To arrange a demo or speak to our sales team, simply fill out this form or call us on ',
      { tag: 'a', options: { innerText: '020 3880 8461', attrs: { href: 'tel:02038808461' } } },
    ],
    form: {
      fields: [
        {
          tag: 'input',
          type: 'text',
          name: 'fullName',
          label: 'Full Name',
          placeholder: '',
          required: true,
          rules: {
            minLength: 2,
          },
        },
        {
          tag: 'input',
          type: 'email',
          name: 'emailAddress',
          label: 'Email Address',
          placeholder: '',
          required: true,
        },
        {
          tag: 'input',
          type: 'number',
          name: 'phoneNumber',
          label: 'Phone Number',
          placeholder: '',
          required: false,
        },
        {
          tag: 'textarea',
          name: 'message',
          label: 'Message',
          placeholder: 'Message',
          required: true,
        },
      ],
      rules: [
        'By submitting your details, you agree to us contacting you. We will not pass your details to any third parties. For further information on how we manage your personal data, or to be removed from our records please email ',
        { tag: 'a', options: { innerText: 'hello@artificial.io', attrs: { href: 'mailto:hello@artificial.io' } } },
      ],
      button: 'Send message',
    },

  },
  ArLocations: {
    title: 'Locations',
    description: 'We’re based in the heart of the City of London with a sister office in Warsaw’s bustling cultural centre.',
    locations: [
      {
        geoPosition: {
          lat: '51.513264',
          lng: '-0.093546',
        },
        city: 'London',
        phone: '020 3880 8461',
        fullAddress: '10 Bow Lane, London, EC4M 9AL, UK',
        description: 'We moved into our new HQ in 2017, Located on the period Bow Lane, we are based in the heart of London’s financial district.',
      },
      {
        geoPosition: {
          lat: '52.222104',
          lng: '21.011837',
        },
        city: 'Warsaw',
        fullAddress: 'Koszykowa 61, 00-667, Warsaw, Poland',
        description: 'Our new Warsaw office is nestled in the beautiful Hala Koszyki building. The office is surrounded by cultural eclecticism and is the perfect space for the team to work collaboratively and creatively.',
      },
    ],
  },
  ArFormContact: {
    fields: {

    },
  },
}
